import { useEffect } from 'react';
import { useLocation, matchPath } from 'react-router';
import googleTagManagerService from 'app/ui/google-tagmanager-service';

export const NewPageTracker = ({ routeMap }) => {
    const location = useLocation();
    useEffect(() => {
        const matchedPage = Object.keys(routeMap).find(pageName => {
            const page = routeMap[pageName];
            return matchPath(location.pathname, {
                path: page.path,
                exact: page.exact || false,
                strict: page.strict || false
            });
        });
        const page = routeMap[matchedPage];
        if (page) {
            googleTagManagerService.newPage(page.pageType);
            googleTagManagerService.trackPageView();
        }
    }, [location, routeMap]);
    return null;
};
